export const colors = {
    darkBackground: '#0b0c0d',
    lightBackground: '#f4f6f8'
};